import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { Row, Col } from "antd";
import config from "../config.json";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <Fragment>
        <img
            alt="Logo"
            width="100%"
            height="100%"
            src={config.login.notFound}
        />
    </Fragment>
  );
}
